import React from 'react';
import { Box, ButtonBase, TextField } from '@mui/material';

function ColorPallet({curColorValue, onUpdate}) {

	const colors = [
		"#ffffff", "#f3f3f3", "#fce9e9", "#fff2d0", "#d9edde", "#e0f3fc", "#e1eaf7", "#c6b3d8",
		"#ffffff", "#d1d1d1", "#f7959d", "#fcbc74", "#97d0ae", "#ace0f8", "#aec6e7", "#8974b3",
		"#272123", "#59595b", "#ee165c", "#f16621", "#19b16a", "#0abaf2", "#027ac6", "#5c2d91",
	];

	const [colorValue,setColorValue] = React.useState(curColorValue);

	const ROW_SIZE = 8;

	function handleColorSelect(idx) {
		console.log("color selected: idx = " + idx);
		let cv = idx == 0 ? "" : colors[idx];

		setColorValue(cv);

		if (onUpdate) {
			onUpdate(cv);
		}
	}

	function handleColorValueChange(e) {
		console.log("color value entered: color value = " + e.target.value);
		let cv = e.target.value;

		if (!cv.startsWith('#')) {
			cv = '#' + cv;
		}

		let accepted = '#';
		for (let i = 1; i < cv.length && i < 7; i++) {
			if (/^[0-9A-F]$/i.test(cv[i])) {
				accepted += cv[i];
			}
		}
		setColorValue(accepted);

		if (accepted.length >= 7) {
			console.log('accepted = ' + accepted);
			if (onUpdate) {
				console.log('callback called');
				onUpdate(accepted);
			}
		}
	}

	function getCircle(idx) {
		const r = 12;
		const cw = 2 * r;
		const ch = cw;
	
		let circles = [];
	
		let iX = idx % ROW_SIZE;
		let iY = Math.floor(idx / ROW_SIZE);
	
		let gapX = 12.5;
		let x = iX * (2 * r + gapX);
		let y = iY * (2 * r + 20);
	
		let fillColor = colors[idx];
		let strokeWidth, color, p1, p2;
		if (iX === 0) {
			if (iY === 0) {
				fillColor = '#ffffff';
				color = '#d3d3d3';
				strokeWidth = `${1/360 * 100}vw`;
				p1 = {
					x: r + 6 * Math.sqrt(2), 
					y: r - 6 * Math.sqrt(2), 
				};
				p2 = {
					x: r - 6 * Math.sqrt(2), 
					y: r + 6 * Math.sqrt(2), 
				};
			}
			else if (iY === 1) {
				color = '#d3d3d3';
				strokeWidth = `${1/360 * 100}vw`;
			}
		}

		return (
			<ButtonBase
				onClick={e => handleColorSelect(idx)}
				sx={{
					position: 'absolute',
					left: `${x/360 * 100}vw`,
					top: `${y/360 * 100}vw`,
					width: `${cw/360 * 100}vw`,
					height: `${ch/360 * 100}vw`,
					borderRadius: `${r/360 * 100}vw`,
				}}
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width={`${cw/360 * 100}vw`}
					height={`${ch/360 * 100}vw`}
				>
					<circle
						cx={`${r/360 * 100}vw`}
						cy={`${r/360 * 100}vw`}
						r={`${r/360 * 100}vw`}
						fill={fillColor}
						strokeWidth={strokeWidth}
						stroke={color}
					/>
					{
						p1 && p2 &&
						<line
							x1={`${p1.x/360 * 100}vw`}
							y1={`${p1.y/360 * 100}vw`}
							x2={`${p2.x/360 * 100}vw`}
							y2={`${p2.y/360 * 100}vw`}
							style={{
								stroke: '#d3d3d3',
								//stroke: '#e8e8e8',
								strokeWidth: `${1/360 * 100}vw`
							}}
						/>
					}
				</svg>
			</ButtonBase>
		);
	}

	let circles = [];
	
	for (let i = 0; i < colors.length; i++) {
		circles.push(getCircle(i));
	}

	return (
		<Box
			display='flex'
			flexDirection='column'
			justifyContent='center'
			alignItems='center'
			sx={{
				marginTop: `${10/360 * 100}vw`,
				borderStyle: 'solid',
				borderWidth: `${0.6/360 * 100}vw`,
				borderColor: '#e8e8e8',
				borderRadius: `${10/360 * 100}vw`,
				padding: `${20/360 * 100}vw`,
			}}
		>
			<div
				style = {{
					width: `${280/360 * 100}vw`,
					height: `${112/360 * 100}vw`,
					position:'relative',
					//border: '2px solid red'
				}}
			>
				{circles}
			</div>
			<TextField
				variant='outlined'
				placeholder='#000000'
				onChange={handleColorValueChange}
				value={colorValue}
				sx={{
					marginTop: `${20/360 * 100}vw`,
					width: `${280/360 * 100}vw`,
					height: `${44/360 * 100}vw`,
					//borderWidth: `${0.6/360 * 100}vw`,
					//borderColor: '#aeaeae',
					//borderStyle: 'solid',
					//borderRadius: `${10/360 * 100}vw`,
				}}
			/>
		</Box>
	);
}

export default ColorPallet;
